__turbopack_context__.v({
  "container": "ULJqTW_container",
  "icon": "ULJqTW_icon",
  "isActive": "ULJqTW_isActive",
});
